import { CalendarHolidays } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeCalendarHolidays(httpClient: HttpClient) {
  return (calendarHolidays: CalendarHolidays) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/calendarHolidayses/${calendarHolidays.uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => calendarHolidays);
}

export { removeCalendarHolidays };
